'use strict';

var Header = require('./Header.js');
var Footer = require('./Footer.js');
var FooterButton = require('./FooterButton.js');
var Dialog = require('./Dialog.js');

const Modal = {
    Header: Header.ModalHeader,
    Footer: Footer.ModalFooter,
    FooterButton: FooterButton.ModalFooterButton,
    Dialog: Dialog.ModalDialog,
};

exports.Modal = Modal;
//# sourceMappingURL=index.js.map
